import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import RiskQueue from "@/pages/RiskQueue";
import Students from "@/pages/Students";
import StudentProfile from "@/pages/StudentProfile";
import Interventions from "@/pages/Interventions";
import Insights from "@/pages/Insights";

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Overview />} />
            <Route path="/risk-queue" element={<RiskQueue />} />
            <Route path="/students" element={<Students />} />
            <Route path="/students/:id" element={<StudentProfile />} />
            <Route path="/interventions" element={<Interventions />} />
            <Route path="/insights" element={<Insights />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
